<template>
  <b-row style="height: 85vh; overflow-y: scroll">
    <b-col cols="10" offset="1">
      <b-tabs
        v-model="$store.state.tabIndex"
        justified
        fill
      >
        <b-tab>
          <template v-slot:title>
            <b-icon icon="search"></b-icon>
            <hr
              style="
                margin: 0px;
                position: absolute;
                width: 12%;
                top: 2%;
                left: 18%;
              "
              class="new4"
            />
            <i style="
                font-weight: 100;
                font-size: 1vw;
                position: absolute;
                top: 55px;
                left: 9%;
              ">Search</i>
          </template>
          <SearchForm />
        </b-tab>
        <b-tab :disabled="$store.state.reviewTab">
          <template v-slot:title>
            <b-icon icon="building"></b-icon>
            <hr
              style="
                margin: 0px;
                position: absolute;
                width: 12%;
                top: 2%;
                left: 42%;
              "
              class="new4"
            />
            <i style="
                font-weight: 100;
                position: absolute;
                top: 55px;
                font-size: 1vw;
                left: 28%;
              ">Review Company</i>
          </template>
          <ReviewForm />
        </b-tab>
        <b-tab :disabled="$store.state.associateTab">
          <template v-slot:title>
            <b-icon icon="people"></b-icon>
            <hr
              style="
                margin: 0px;
                position: absolute;
                width: 12%;
                top: 2%;
                left: 66%;
              "
              class="new4"
            />
            <i style="
                font-weight: 100;
                position: absolute;
                top: 55px;
                font-size: 1vw;
                left: 51%;
              ">Associated Individuals</i>
          </template>
          <AssociateForm />
        </b-tab>
        <b-tab :disabled="$store.state.resultTab">
          <template v-slot:title>
            <b-icon icon="download"></b-icon>
            <i style="
                font-weight: 100;
                position: absolute;
                top: 55px;
                font-size: 1vw;
                left: 78%;
              ">Review Results</i>
          </template>
          <ReviewResult />
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>

<script>
import SearchForm from "./searchFormComponent";
import ReviewForm from "./reviewCompanyResult";
import AssociateForm from "./associateIndividualsForm";
import ReviewResult from "./reviewResult.vue";
export default {
  name: "mainPageForm",
  components: {
    SearchForm,
    ReviewForm,
    AssociateForm,
    ReviewResult,
  },
};
</script>

<style scoped>
/* @import "../../assets/styles/theme1/ferovialTabs.css"; */
.nav-tabs .nav-link.active {
    color: black !important;
    font-weight: bold;
    /* background-color: #ffffff !important; */
    /* border-color: #ffffff !important; */
    border-bottom: 3px solid #425edc !important;
    width: 50px !important;
    border-radius: 51%;
    background: black;
    border-radius: 60%;
    border-top: 3px solid #425edc !important;
  }
  .nav-tabs li.nav-item {
    /* border-bottom: 3px red #f7f7f7; */
    margin-right: 25px;
    text-align: -webkit-center;
  }
  .nav-tabs .nav-link {
    color: black !important;
    border-bottom: 3px solid #f7f7f7 !important;
    font-weight: bold;
    color: black !important;
    font-weight: bold;
    background-color: #ffffff !important;
    border-color: #ffffff !important;
    border-bottom: 3px solid #42dc98 !important;
    width: 50px !important;
    border-radius: 51%;
    background: black;
    border-radius: 60%;
    border-top: 3px solid #42dc98 !important;
  }
  .nav-tabs .nav-link.active:hover {
    background-color: #ffffff !important;
    border-color: #ffffff !important;
    border-bottom: 3px solid #425edc !important;
    border-top: 3px solid #425edc !important;
  }
  .nav-tabs .nav-link:hover {
    background-color: #def0dd !important;
    border-color: #def0dd !important;
    border-bottom: 3px solid #42dc98 !important;
    border-top: 3px solid #42dc98 !important;
  }
  hr.new5 {
    border: 10px solid green;
    border-radius: 5px;
  }
</style>
<style>
hr.new4 {
  border: 2px solid #42dc98;
}
</style>